import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { ClientesService } from 'src/app/services/clientes.service';
import { GruposService } from 'src/app/services/grupos.service';


@Component({
  selector: 'app-registro-interno',
  templateUrl: './registro-interno.component.html',
  styleUrls: ['./registro-interno.component.scss']
})
export class RegistroInternoComponent implements OnInit {
  grupoid:any;
  formulario2:any;
  data:any;
  grupo:any;
  input:any;

  respuestaDetalle:any;
  respuestaAgregar:any;
  errorMsg:any;

  public isChecked = false;
  constructor( private _getDetalleGrupo: GruposService, private actRoute:ActivatedRoute,
    private iziToast:Ng2IzitoastService, private modalService: NgbModal, private _agregarCliente: ClientesService,) { }

  ngOnInit(): void {
    this.actRoute.paramMap.subscribe(params => {
      this.grupoid = this.actRoute.snapshot.paramMap.get('grupo');
      if ( this.grupoid){
        this.getDetalleGrupo(this.grupoid);
      }
      
    });

    this.formulario2 = {
      nombre:'',
      apellidos:'',
      apellido_materno:'',
      celular:'',
      email:'',
      password:'',
      password2:'',
    }
  }

  getDetalleGrupo(grupoid){
    this.data = {
      'grupo':grupoid,
    }
    this._getDetalleGrupo.getDetalleGrupo(this.data).subscribe(
      data => {
        this.respuestaDetalle = data;
        if(this.respuestaDetalle.success){
          this.grupo = this.respuestaDetalle.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  validateRegistro(){
    if (this.formulario2.nombre == ''){
      this.iziToast.show(
        {
            title: 'Por favor ingresa tu nombre.',
            titleColor: '#f8f8ff',
            color: '#DC143C',
            position: 'topRight',
            closeOnEscape: true,
        });
      return;
    }
    if (this.formulario2.apellidos == ''){
      this.iziToast.show(
        {
            title: 'Por favor ingresa tu apellido paterno.',
            titleColor: '#f8f8ff',
            color: '#DC143C',
            position: 'topRight',
            closeOnEscape: true,
        });
      return;
    }
    if (this.formulario2.apellido_materno == ''){
      this.iziToast.show(
        {
            title: 'Por favor agrega tu apellido materno.',
            titleColor: '#f8f8ff',
            color: '#DC143C',
            position: 'topRight',
            closeOnEscape: true,
        });
      return;
    }

    if (this.formulario2.celular == ''){
      this.iziToast.show(
        {
            title: 'Por favor agrega un número telefónico.',
            titleColor: '#f8f8ff',
            color: '#DC143C',
            position: 'topRight',
            closeOnEscape: true,
        });
      return;
    }

    if (this.formulario2.password == ''){
      this.iziToast.show(
        {
            title: 'Por favor agrega una contraseña.',
            titleColor: '#f8f8ff',
            color: '#DC143C',
            position: 'topRight',
            closeOnEscape: true,
        });
      return;
    }

    if (this.formulario2.password2 == ''){
      this.iziToast.show(
        {
            title: 'Por favor confirma tu contraseña.',
            titleColor: '#f8f8ff',
            color: '#DC143C',
            position: 'topRight',
            closeOnEscape: true,
        });
      return;
    }

    if (this.formulario2.password2 != this.formulario2.password){
      this.iziToast.show(
        {
            title: 'Las contraseñas no coinciden.',
            titleColor: '#f8f8ff',
            color: '#DC143C',
            position: 'topRight',
            closeOnEscape: true,
        });
      return;
    }

    document.getElementById('terminosycondiciones').click();
  }


  registrarUsuario(grupoid){
    this.data = {
      'grupo': grupoid,
      'first_name': this.formulario2.nombre,
      'last_name': this.formulario2.apellidos,
      'apellido_materno': this.formulario2.apellido_materno,
      'celular': this.formulario2.celular,
      'email': this.formulario2.email,
      'password': this.formulario2.password,
      'username': this.formulario2.celular,
    }

    if (this.isChecked == false){
      this.iziToast.show(
        {
            title: 'Debes aceptar los términos y condiciones',
            titleColor: '#f8f8ff',
            color: '#DC143C',
            position: 'topRight',
            closeOnEscape: true,
        });
      return;
    }

    this._agregarCliente.agregarClienteGrupoV2(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado el cliente correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });

          
          
          this.formulario2.nombre = '';
          this.formulario2.apellidos = '';
          this.formulario2.celular = '';
          this.formulario2.email = '';
          this.formulario2.password = '';
          this.formulario2.password2 = '';

          setTimeout(() => {
            this.dismissAll();
            window.location.reload();

          }, 2000);
          ;

        }else {
          this.iziToast.show(
            {
                title: this.respuestaAgregar.error,
                titleColor: '#ffffff',
                color: '#CA0B00',
                position: 'topRight',
                closeOnEscape: true,
            });
        }
      }, error => console.error(error));
      
  }


  openModal(modal) {
    this.modalService.open(modal, { size: 'md' });
  }


  dismissAll() {
    this.modalService.dismissAll();
  }

}
